import '../../styles/UserSettings.css';



export function ImessageThemePreview () {
    /* --- iMESSAGE PREVIEW --- */
    return (
        <div className="imessage-container imessage-dark">
            <div className="imessage-row imessage-row--left">
            <div className="imessage-bubble max-w-[75%] imessage-bubble--left">
                Hey! I love the way this iMessage layout theme looks!
            </div>
            </div>

            <div className="imessage-row imessage-row--right">
            <div className="imessage-bubble max-w-[75%] imessage-bubble--right">
                Yeah! Just finished setting it up on my FamChat too!.
            </div>
            </div>
        </div>
    )
}

export function DiscordThemePreview () {
    /* --- DISCORD PREVIEW --- */
    return (
        <div className="discord-container ">
            {/* Parent Group Header (First Message with Name) */}
            <div className="discord-message-row discord-message-row--first">
                <div className="discord-avatar-wrapper">
                    <div className="discord-avatar flex items-center justify-center">U</div>
                </div>
                <div className="discord-body">
                    <div className="discord-meta">
                    <span className="discord-author">UserOne</span>
                    <span className="discord-timestamp">Today at 4:15 PM</span>
                    </div>
                    <div className="discord-text">
                        Hey everyone, look at this Discord layout scheme.
                    </div>
                </div>
            </div>

            {/* Subsequent Message (Grouped, No Avatar, Inline Hover Time) */}
            <div className="discord-message-row discord-message-row--subsequent">
                {/* <div className="discord-hover-time">4:16 PM</div> */}
                <div className="discord-body">
                    <div className="discord-text">
                    It looks exactly like the desktop client.
                    </div>
                </div>
            </div>

            {/* USER 2: A different user replies (New Avatar & Metadata block) */}
            <div className="discord-message-row discord-message-row--first">
                <div className="discord-avatar-wrapper">
                    {/* Different avatar color to simulate a different user */}
                    <div className="discord-avatar flex items-center justify-center" style={{ backgroundColor: '#23a55a' }}>T</div> 
                    </div>
                        <div className="discord-body">
                            <div className="discord-meta">
                            <span className="discord-author">UserTwo</span>
                            <span className="discord-timestamp">Today at 4:17 PM</span>
                        </div>
                            <div className="discord-text">
                                Wow, that looks way just like Discord!
                            </div>
                        </div>  
                </div>
            </div>
    )
}

